// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89827c50","640":"495c480e","828":"adb452f4"}[chunkId] + ".chunk.js";
};